import { SeriesPointXY, SeriesPointX0Y, SeriesPointXY0 } from '../Types';

export { default as getAxisLine } from './getAxisLine';
export { default as getCurve } from './getCurve';
export { default as getOrigin } from './getOrigin';
export { default as getStackedSeries } from './getStackedSeries';
export { default as getXStepFromSeries } from './getXStepFromSeries';
export { default as mergeRefs } from './mergeRefs';
export { default as useGetNearestPoint } from './useGetNearestPoint';
export { default as usePathMorph } from './usePathMorph';
export { default as useReferenceElement } from './useReferenceElement';
export { default as useResizeObserver } from './useResizeObserver';
export { default as useTicks } from './useTicks';

export {
  default as getScale,
  getScaleBandWidth,
  getScaleInvert,
  getScalePadding,
  getScaleTicks,
} from './getScale';

export const noTransition = {
  duration: 0,
  type: false,
};

export const definedAccessorXY = (point: SeriesPointXY): boolean => point.x !== null && point.y !== null;
export const definedAccessorX0Y = (point: SeriesPointX0Y): boolean => point.x !== null && point.y !== null && point.x0 !== null;
export const definedAccessorXY0 = (point: SeriesPointXY0): boolean => point.x !== null && point.y !== null && point.y0 !== null;
export const pointXAccessor = (point: SeriesPointXY): number => point.x as number;
export const pointYAccessor = (point: SeriesPointXY): number => point.y as number;
export const pointY0Accessor = (point: SeriesPointXY0): number => point.y0 as number;
